export default __webpack_public_path__ + "static/media/581.2251b8f0.png";